import { useState, useEffect } from "react";
import DataTableComponent from "../../components/DataTableComponent";

export default function ProvinceTable({ provinceData }) {
  const [filterValue, setFilterValue] = useState("");
  const [displayData, setDisplayData] = useState(provinceData);

  useEffect(() => {
    setDisplayData(
      provinceData.filter(
        (item) =>
          item.regione &&
          item.regione.toLowerCase().includes(filterValue.toLowerCase())
      )
    );
  }, [filterValue]);

  const columns = [
    {
      name: "Provincia",
      selector: (row) => row.provincia,
      sortable: true,
    },
    {
      name: "Regione",
      selector: (row) => row.regione,
      sortable: true,
    },
    {
      name: "Numero compilazioni",
      selector: (row) => row.count,
      sortable: true,
    },
  ];

  const handleChange = (e) => {
    setFilterValue(e.target.value);
  };

  return (
    <>
      <DataTableComponent
        columns={columns}
        displayData={displayData}
        filterValue={filterValue}
        handleChange={handleChange}
        placeholder='Regione'
        defaultSortFieldId={3}
        defaultSortAsc={false}
      />
    </>
  );
}
